import { render, staticRenderFns } from "./LayoutList.vue?vue&type=template&id=7728249c"
import script from "./LayoutList.vue?vue&type=script&lang=js"
export * from "./LayoutList.vue?vue&type=script&lang=js"
import style0 from "./LayoutList.vue?vue&type=style&index=0&id=7728249c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7728249c')) {
      api.createRecord('7728249c', component.options)
    } else {
      api.reload('7728249c', component.options)
    }
    module.hot.accept("./LayoutList.vue?vue&type=template&id=7728249c", function () {
      api.rerender('7728249c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layout/LayoutList.vue"
export default component.exports